import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { OrderStatus, OrderStatusMap } from '@application/common/enums/order-status';
import { setWorkOrderNumberAtOrder } from '@application/features/orders/orderSlice';
import { getOrdersByWorkOrderIdAsync } from '@application/features/workorders/workorderThunk';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { formatDMY } from '@infrastructure/helpers';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
const OrdersTable = ({ onRowClick, isOrderTabBold }) => {
    const dispatch = useAppDispatch();
    const { id } = useParams();
    const { workorderOrders } = useAppSelector((state) => state.workorder);
    const navigate = useNavigate();
    useEffect(() => {
        if (id) {
            dispatch(getOrdersByWorkOrderIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                if (isOrderTabBold && res.length > 0) {
                    isOrderTabBold(true);
                }
                else {
                    isOrderTabBold && isOrderTabBold(false);
                }
            });
        }
    }, [id]);
    useEffect(() => {
        return () => {
            dispatch(setWorkOrderNumberAtOrder(undefined)); // Dispatch the action to clear workOrderNumber
        };
    }, [dispatch]);
    function calculateTooLate(deliveryDate, status) {
        if (status == OrderStatus.In_bestelling) {
            const currentDate = new Date();
            const timeDifference = new Date(deliveryDate).getTime() - currentDate.getTime();
            const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
            return daysDifference < 0 ? Math.abs(daysDifference) : 0;
        }
        else
            return 0;
    }
    function handleRowClick(id) {
        navigate(`/admin/OrderTabs/${id}`);
    }
    return (_jsx(_Fragment, { children: _jsx("div", { className: 'custom-table-container', style: { marginTop: "36px" }, children: _jsx("div", { className: 'vn-table-container', children: _jsx("div", { className: 'vn-main', children: _jsxs("table", { className: 'table', children: [_jsx("thead", { className: 'vn-table-thead', children: _jsxs("tr", { className: 'vn-custom-grid-header-card', children: [_jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Bestelnummer" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Leverancier" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Besteldatum" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Leverdatum" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Dagen te laat" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Status" }) })] }) }), _jsx("tbody", { className: 'vn-table-tbody', children: workorderOrders?.map((order) => (_jsxs("tr", { onClick: (e) => {
                                        handleRowClick(order.id);
                                    }, style: { cursor: 'pointer' }, children: [_jsx("td", { children: _jsx("span", { children: order.orderNumber }) }), _jsx("td", { children: _jsx("span", { children: order.supplierName }) }), _jsx("td", { children: _jsx("span", { children: order.orderDate ? formatDMY(order.orderDate.toString()) : _jsx("span", {}) }) }), _jsx("td", { children: _jsx("span", { children: order.deliveryDate ? formatDMY(order.deliveryDate.toString()) : _jsx("span", {}) }) }), _jsx("td", { children: _jsx("span", { children: calculateTooLate(order.deliveryDate, order.statusId) }) }), _jsx("td", { children: _jsx("span", { children: OrderStatusMap.get(order.statusId) }) })] }, order.id))) })] }) }) }) }) }));
};
export default OrdersTable;
